import { AdminLayout } from "@superadmin/components/AdminLayout";
import { ErrorFallback } from "@superadmin/components/ErrorFallback";
import { AgentConfigPage } from "@superadmin/pages/AgentConfig.page";
import { ContainerEnvPage } from "@superadmin/pages/ContainerEnv.page";
import { CostingPage } from "@superadmin/pages/Costing.page";
import { DashboardPage } from "@superadmin/pages/Dashboard.page";
import { DeniedPage } from "@superadmin/pages/Denied.page";
import { FeatureFlagsPage } from "@superadmin/pages/FeatureFlags.page";
import { LoginPage } from "@superadmin/pages/Login.page";
import { PhoneNumbersPage } from "@superadmin/pages/PhoneNumbers.page";
import { PlatformPromptPage } from "@superadmin/pages/PlatformPrompt.page";
import { PricingPage } from "@superadmin/pages/Pricing.page";
import { ProvidersPage } from "@superadmin/pages/Providers.page";
import { SessionDetailPage } from "@superadmin/pages/SessionDetail.page";
import { SessionsPage } from "@superadmin/pages/Sessions.page";
import { TeamsPage } from "@superadmin/pages/Teams.page";
import { TenancyAuditPage } from "@superadmin/pages/TenancyAudit.page";
import { adminLoader } from "@superadmin/utils/admin.loader";
import { createBrowserRouter, redirect } from "react-router";

/**
 * One bundle, no route-level code splitting. The tenant dashboard splits
 * because customers pay its load time; this is an internal tool whose whole
 * JS is smaller than one of that app's chunks, and splitting would buy the
 * stale-chunk-reload machinery apps/frontend needs to carry for it.
 */
export const router = createBrowserRouter([
	{
		path: "/",
		errorElement: <ErrorFallback />,
		children: [
			{ index: true, loader: () => redirect("/dashboard") },
			{ path: "auth/login", Component: LoginPage },
			{ path: "auth/denied", Component: DeniedPage },
			{
				Component: AdminLayout,
				loader: adminLoader,
				// The gate has no inputs that change between navigations —
				// re-running it on every click would spend the 30 req/min
				// super-admin budget on pings.
				shouldRevalidate: () => false,
				children: [
					{ path: "dashboard", Component: DashboardPage },
					{ path: "sessions", Component: SessionsPage },
					{ path: "sessions/:sessionId", Component: SessionDetailPage },
					// Two pages rather than one: the numbers and the rates behind
					// them are read by different people at different times, and a
					// price editor sitting under a spend table invites editing a
					// rate to make a total look better.
					{ path: "costing", Component: CostingPage },
					{ path: "pricing", Component: PricingPage },
					{ path: "phone-numbers", Component: PhoneNumbersPage },
					{ path: "providers", Component: ProvidersPage },
					{ path: "teams", Component: TeamsPage },
					{ path: "tenancy-audit", Component: TenancyAuditPage },
					{ path: "feature-flags", Component: FeatureFlagsPage },
					{ path: "container-env", Component: ContainerEnvPage },
					{ path: "agent-config", Component: AgentConfigPage },
					{ path: "system-prompt", Component: PlatformPromptPage },
				],
			},
		],
	},
]);
